import { PROVINCES_CONST, provincesWithLetterIBM } from './provinces/provinces';
import { CODIGO_POSTAL } from './postal-codes/codigo-postal';
import { PlaceOfOrigin } from './locations.interface';

/* LOCALITIES */
import { buenosAiresLocalities } from './provinces/locations-of-buenos-aires';
import { cabaLocalities } from './provinces/locations-of-caba';
import { catamarcaLocalities } from './provinces/locations-of-catamarca';
import { chacoLocalities } from './provinces/locations-of-chaco';
import { chubutLocalities } from './provinces/locations-of-chubut';
import { cordobaLocations } from './provinces/locations-of-cordoba';
import { corrientesLocalities } from './provinces/locations-of-corrientes';
import { entreRiosLocalities } from './provinces/locations-of-entre-rios';
import { formosaLocalities } from './provinces/locations-of-formosa';
import { jujuyLocalities } from './provinces/locations-of-jujuy';
import { laPampaLocalities } from './provinces/locations-of-la-pampa';
import { laRiojaLocalities } from './provinces/locations-of-la-rioja';
import { mendozaLocalities } from './provinces/locations-of-mendoza';
import { misionesLocalities } from './provinces/locations-of-misiones';
import { neuquenLocalities } from './provinces/locations-of-neuquen';
import { rioNegroLocalities } from './provinces/locations-of-rio-negro';
import { saltaLocalities } from './provinces/locations-of-salta';
import { sanJuanLocalities } from './provinces/locations-of-san-juan';
import { sanLuisLocalities } from './provinces/locations-of-san-luis';
import { santaCruzLocalities } from './provinces/locations-of-santa-cruz';
import { santaFeLocalities } from './provinces/locations-of-santa-fe';
import { santiagoDelEsteroLocalities } from './provinces/locations-of-santiago-del-estero';
import { tierraDelFuegoLocalities } from './provinces/locations-of-tierra-del-fuego';
import { tucumanLocalities } from './provinces/locations-of-tucuman';

/*Given an index that represents the province number. Returns an array with all the towns in the province*/
export function getLocality(index: number): any {
    let location: any = [];
    switch (index) {
        case PROVINCES_CONST.BUENOS_AIRES: location = buenosAiresLocalities; break;
        case PROVINCES_CONST.CABA: location = cabaLocalities; break;
        case PROVINCES_CONST.CATAMARCA: location = catamarcaLocalities; break;
        case PROVINCES_CONST.CHACO: location = chacoLocalities; break;
        case PROVINCES_CONST.CHUBUT: location = chubutLocalities; break;
        case PROVINCES_CONST.CORDOBA: location = cordobaLocations; break;
        case PROVINCES_CONST.CORRIENTES: location = corrientesLocalities; break;
        case PROVINCES_CONST.ENTRE_RIOS: location = entreRiosLocalities; break;
        case PROVINCES_CONST.FORMOSA: location = formosaLocalities; break;
        case PROVINCES_CONST.JUJUY: location = jujuyLocalities; break;
        case PROVINCES_CONST.LA_PAMPA: location = laPampaLocalities; break;
        case PROVINCES_CONST.LA_RIOJA: location = laRiojaLocalities; break;
        case PROVINCES_CONST.MENDOZA: location = mendozaLocalities; break;
        case PROVINCES_CONST.MISIONES: location = misionesLocalities; break;
        case PROVINCES_CONST.NEUQUEN: location = neuquenLocalities; break;
        case PROVINCES_CONST.RIO_NEGRO: location = rioNegroLocalities; break;
        case PROVINCES_CONST.SALTA: location = saltaLocalities; break;
        case PROVINCES_CONST.SAN_JUAN: location = sanJuanLocalities; break;
        case PROVINCES_CONST.SAN_LUIS: location = sanLuisLocalities; break;
        case PROVINCES_CONST.SANTA_CRUZ: location = santaCruzLocalities; break;
        case PROVINCES_CONST.SANTA_FE: location = santaFeLocalities; break;
        case PROVINCES_CONST.SANTIAGO_DEL_ESTERO: location = santiagoDelEsteroLocalities; break;
        case PROVINCES_CONST.TIERRA_DEL_FUEGO: location = tierraDelFuegoLocalities; break;
        case PROVINCES_CONST.TUCUMAN: location = tucumanLocalities; break;
    }
    return Object.values(location);
}

export function getCodPost(placeOfOrigin: PlaceOfOrigin) {
    try {
        //const locality:any=this.orderV.getLocality(placeOfOrigin.province)[placeOfOrigin.town - 1];
        const loc: any = getLocality(placeOfOrigin.province)[placeOfOrigin.town - 1]?.location;
        let codePostal = 0;
        if (loc) {
            codePostal = searchCodePostalByAfipCode(placeOfOrigin.afip);
            if (codePostal == 0) {
                codePostal = searchCodePostal(loc, placeOfOrigin.province);
            }
        }
        return codePostal;
    } catch (err) {
        console.error(err);
        return 1000;
    }
}

function searchCodePostal(locality: string, province: number) {
    const provincesWithLetterIBMConst: any = provincesWithLetterIBM;
    const codePostals: any = CODIGO_POSTAL;

    const provinceMatchWithIBM = provincesWithLetterIBMConst[province];
    const quantItems = codePostals.length;

    const localityLowerCase = locality.toLocaleLowerCase();

    let valueToReturn = 0;
    try {
        for (let i = 0; i < quantItems; i++) {
            const descriptionLowerCase = codePostals[i].DESCRIPCION.toLocaleLowerCase();
            if ((descriptionLowerCase == localityLowerCase ||
                descriptionLowerCase == localityLowerCase.replace("ñ", "n")) &&
                codePostals[i].PROVINCIA == provinceMatchWithIBM) {
                valueToReturn = codePostals[i]["CODIGO POSTAL"];
                throw new Error();
            }
        }
    } catch (err) { }

    return valueToReturn;
}

function searchCodePostalByAfipCode(afipCode: number) {
    const codePostals: any = CODIGO_POSTAL;
    const quantItems = codePostals.length;
    let valueToReturn = 0;
    try {
        for (let i = 0; i < quantItems; i++) {
            if (codePostals[i]["AFIP"] == afipCode) {
                valueToReturn = codePostals[i]["CODIGO POSTAL"];
            }
        }
    } catch (err) { }
    return valueToReturn;
}
